module.exports = __webpack_public_path__ + "img/milling-sel.5c5b2851.svg";